import { Fragment, useMemo, useState } from 'react';
import { Box, Button } from '@mui/material';
import FaceplateExcerpt from './FaceplateExcerpt';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../actions/product_builder';
import buttons from '../../styles/buttons.module.css';
import typography from '../../styles/typography.module.css';
import { useTranslation } from 'react-i18next';
const setTitle = (side, faceplate, material) => {
    const currFaceplate = faceplate[side === 'both' ? 'leftOption' : side + 'Option'];
    if (currFaceplate.SK.includes(material.toUpperCase())) {
        return currFaceplate.displayName;
    } else return '\xa0';
};
let FaceplateOptionList = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const currentFaceplate = useSelector((state) => state.rootReducer.currentFaceplateOption);
    const currentSide = useSelector((state) => state.rootReducer.settingsOptions.currentSide);
    const currentFaceplateType = useSelector(
        (state) => state.rootReducer.currentFaceplateType.activeFaceplateType
    );
    const defaultShopifyModelInfo = useSelector((state) => state.shopifyReducer.ciems[0]);
    const [selected, setSelected] = useState(null);
    const displayName = useMemo(
        () => setTitle(currentSide, currentFaceplate, props.title),
        [currentSide, currentFaceplate]
    );

    let additionalPrice = useMemo(() => {
        const faceplatePrice = parseInt(props.faceplates[0].price, 10);
        const totalPrice =
            faceplatePrice +
            (faceplatePrice > 0 ? faceplatePrice * process.env.REACT_APP_TAX_RATE : 0);
        return props.faceplates[0].price.localeCompare('0.00') === 1
            ? ` + ${defaultShopifyModelInfo.currency}  ${totalPrice.toFixed(2)} ${t('per_side')}`
            : '';
    }, []);

    let content = props.faceplates.map((faceplate) => {
        return (
            <FaceplateExcerpt
                key={faceplate.SK}
                faceplate={faceplate}
                isCurrent={faceplate.displayName === displayName}
                setSelected={setSelected}
                selected={selected}
            />
        );
    });

    return (
        <Fragment>
            <Button
                disableRipple={true}
                key={props.title}
                variant="outlined"
                className={
                    props.title === props.activeFaceplateType
                        ? buttons.btnPill + ' ' + buttons.btnMaterialActive
                        : buttons.btnPill + ' ' + buttons.btnMaterial
                }
                onClick={() => {
                    props.title === currentFaceplateType
                        ? dispatch(allActions.faceplateActions.setActiveFaceplateType(null))
                        : dispatch(allActions.faceplateActions.setActiveFaceplateType(props.title));
                }}>
                {props.title}
                <span>&nbsp;</span>
                <span style={{ fontWeight: '300' }}>
                    {props.title === props.activeFaceplateType && additionalPrice}
                </span>
            </Button>
            {props.activeFaceplateType === props.title && (
                <Box>
                    <h4 className={typography.headerTitle} style={{ paddingTop: '30px' }}>
                        {selected ? selected : displayName}
                    </h4>
                    <Box
                        style={{
                            paddingBottom: '10px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'center'
                        }}>
                        {content}
                    </Box>
                </Box>
            )}
        </Fragment>
    );
};

export default FaceplateOptionList;
